module.exports = __webpack_public_path__ + "img/my.3d8571a0.png";